import { RefObject, useEffect } from 'react';
import { useAppSelector } from '@store';

import cn from '../styles.module.css';

const usePortal = (ref: RefObject<HTMLDivElement>) => {
  const {
    accounts: { panelIsOpen },
    groups: { panelIsOpen: groupPanelIsOpen },
    categories: { panelIsOpen: categoryPanelIsOpen },
  } = useAppSelector((state) => state.charts);

  useEffect(() => {
    if (ref.current) {
      if (panelIsOpen) {
        ref.current.classList.add(cn.primaryAccountInSidepanel);
      } else {
        ref.current.classList.remove(cn.primaryAccountInSidepanel);
      }

      if (groupPanelIsOpen || categoryPanelIsOpen) {
        ref.current.classList.add(cn.groupPanel);
      } else {
        ref.current.classList.remove(cn.groupPanel);
      }
    }
  }, [ref, panelIsOpen, groupPanelIsOpen, categoryPanelIsOpen]);
};

export default usePortal;
